/**
 * Öffentliche Schnittstelle des gemeinsamen Pakets.
 *
 * Nach §41.2 sind hier ausschließlich gefahrlos browserseitig nutzbare Typen, Konstanten und
 * Validierungsschemas zulässig. Keine Schlüssel, keine Datenbankzugriffe, keine serverseitige
 * Sicherheitslogik.
 */
export * from './abstimmung.js';
export * from './api.js';
export * from './audit.js';
export * from './auswahlregeln.js';
export * from './backup.js';
export * from './codes.js';
export * from './durchfuehrung.js';
export * from './echtzeit.js';
export * from './email.js';
export * from './export.js';
export * from './health.js';
export * from './personalisierung.js';
export * from './richtext.js';
export * from './session.js';
export * from './systemstatus.js';
export * from './teilnehmer.js';
export * from './textformat.js';
export * from './theme.js';
export * from './token.js';
export * from './veranstaltung.js';
export * from './zeit.js';
/** Anzeigename der Anwendung. Vor der Anmeldung ist nur dieser sichtbar (§9.1). */
export const APP_DISPLAY_NAME = 'mcikmVOTE';
//# sourceMappingURL=index.js.map